import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { welcomePageAPI } from '../services/api';
import { WelcomePage, WelcomeTab } from '../types';

export const useWelcomePage = () => {
  const queryClient = useQueryClient();

  // Get welcome page
  const {
    data: welcomePage,
    isLoading,
    error,
    refetch
  } = useQuery<WelcomePage>({
    queryKey: ['welcomePage'],
    queryFn: welcomePageAPI.get,
  });

  // Update welcome page mutation
  const updateWelcomePage = useMutation({
    mutationFn: (data: { tabs: WelcomeTab[] }) => 
      welcomePageAPI.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['welcomePage'] });
    },
  });

  return {
    welcomePage,
    isLoading,
    error,
    refetch,
    updateWelcomePage: updateWelcomePage.mutate,
    isUpdating: updateWelcomePage.isPending,
  };
};

